import React, {useEffect,useState } from "react";   
import { useNavigate,useParams } from "react-router-dom"; 
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'; 
import GameQuestions from "./GameQuestions" 
import {getGameData} from "../../Services/Games/gamesService" 
import {getEnvUrl } from "../../utils/Api";
import './GlobalGames.css' 
import CreateQuestion from "./popups/createQuestion"
 
require("datatables.net");
const GamesView = () => {
    const [rerender, setRerender] = useState(false); 
    const [qusModal, setQusModal] = useState(false);  
    const [isDisabled, setIsDisabled] = useState(false);  
    const [gameData,setGameData]=useState({})
    const { gameid } = useParams();
    const navigate = useNavigate();
    let pageRerender=()=>{ setGameData({});setRerender(!rerender)}
    let qusModelClose=()=>{
        setQusModal(false)
    } 
    let statusUpdate=(s)=>{ 
        
    }   
    
    useEffect(()=>{
        getGameData(gameid).then((data)=>{
            if(data.status){
                setGameData(data.data)
            }
        })
    },[rerender,gameid])
  return (
    <div> 
   <main id="main" className="main">
   <div className="container custom-width">
        <div className="pagetitle">
            <h1 className="cursor" onClick={()=>{navigate('/masters/games')}}>Game </h1>
            <nav>
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/masters/games">Game</Link></li>
                <li className="breadcrumb-item">Game Detail View</li>
                
            </ol>
            </nav>
        </div>
        {/* End Page Title */}

        <section className="section" id="game-view-page">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body"> 
                        <div className="container">
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label col-lable">Game <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                            <p className="form-control-plaintext">{gameData?.name}</p>
                                        </div>
                                    </div>
                                    
                                    
                                    <div className="form-group row"> 
                                        <label className="col-sm-4 col-form-label col-lable">Subject <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                            <p className="form-control-plaintext">{gameData?.subject?.name}</p>
                                        </div>
                                    </div> 

                                    <div className="form-group row"> 
                                        <label className="col-sm-4 col-form-label col-lable">Grade <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                            <p className="form-control-plaintext">{gameData?.grade?.name}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group row"> 
                                        <label className="col-sm-4 col-form-label col-lable">Game Banner <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                        {gameData?.id? <> <div className="col-auto col-md-8"><img src={`${getEnvUrl()}/admin/media/banner/${btoa(gameData?.banner_key)}?width=125&v=${new Date()}`} alt="Thumbnail" className="img-fluid"/>  
                                        </div></>:''}
                                        </div>
                                    </div> 
                                    
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label col-lable">Description <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                            <p className="form-control-plaintext">{gameData?.description}</p>
                                        </div>
                                    </div>
                                    <div className="form-group row"> 
                                        <label className="col-sm-4 col-form-label col-lable">Category <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                            <p className="form-control-plaintext">{gameData?.gamelevel?.name}</p>
                                        </div>
                                    </div> 
                                  
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label col-lable">Game Thumbnail <span className="colon">:</span></label>
                                        <div className="col-sm-8">
                                        {gameData?.id? <> <div className="col-auto col-md-8"><img src={`${getEnvUrl()}/admin/media/banner/${btoa(gameData?.thumbnail_key)}?width=125&v=${new Date()}`} alt="Thumbnail" className="img-fluid"/>   
                                        </div></>:''}
                                        </div>
                                    </div> 
                                   
                                </div>
                            </div>
                        </div> 
                            <section className="section">
                                <div className="row">
                                <button    onClick={()=>{ setQusModal(true);}} type="button" className={`btn btn-primary col-lg-2 mb ${gameData.status=='PUBLISHED'?'disabled':''}` }>+ Add Question </button>
                                   <div className="col-lg-12">
                                        <div className="card"> 
                                            <div className="card-body">
                                                  <div className="accordion" id="accordionExample">
                                                {(gameData?.game_questions?.length>0)?<GameQuestions game_id={gameid} questions={gameData?.game_questions} pageRerender={pageRerender}/>:<center><strong>No question has been added yet.</strong></center>} 
                                                 </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="text-end mb-3">
                            {gameData?.status==='DRAFT'?
                            <button type="button" disabled={isDisabled} onClick={()=>{statusUpdate('PUBLISHED')}} className="btn btn-primary">PUBLISH</button>:
                            <button type="button" disabled={isDisabled}  onClick={()=>{statusUpdate('DRAFT')}}  className="btn btn-primary">Status Change To DRAFT</button>}  
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</main>  
{qusModal?<CreateQuestion type='CREATE'   qusData={{}} isShow={qusModal} close={qusModelClose} gameId={gameid} pageRerender={pageRerender}/>:''}
</div>
  );
};

export default GamesView; 